module.exports = __webpack_public_path__ + "img/success.de327b8c.svg";